const lobConfig = require('./lob-config');

module.exports = { lobConfig: lobConfig };
